import * as React from 'react';

import { HeaderButton } from '../Header/styles';
import Utils from '../../../utils';
import RoutesUtils from '../../../utils/routes';

interface ButtonBackProps {
	parentId: number;
}

const ButtonBack = ({ parentId }: ButtonBackProps) => (
	<HeaderButton
		iconWidth="10px"
		iconHeight="10px"
		onClick={() => RoutesUtils.redirectToParentDir(parentId)}
	>
		{Utils.getSvgIcon('iconset_close-2')}
	</HeaderButton>
);

export default ButtonBack;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonBack/index.tsx